export default __webpack_public_path__ + "static/media/avatar_58.9f9a34a6.png";